// src/components/AwarenessAreasTab.js
import React from "react";
import awarenessData from "../content/module_awareness_areas.json";

export default function AwarenessAreasTab({ awarenessAreaIds, isMobile, }) {
  if (!Array.isArray(awarenessAreaIds)) {
    return (
      <div style={{ opacity: 0.6, fontSize: 14 }}>
        No awareness data available.
      </div>
    );
  }

  const areas = awarenessData?.areas || [];

  const resolvedAreas = awarenessAreaIds
    .map((id) => areas.find((a) => a.id === id))
    .filter(Boolean);

  return (
    <div style={{ padding: 4 }}>
      {/* Empty State */}

      {/* Empty State */}
      {resolvedAreas.length === 0 && (
        <div style={{
          padding: "12px 16px",
          borderRadius: 10,
          background: "rgba(30,41,59,0.55)",
          border: "1px solid rgba(148,163,184,0.15)",
        }}>
          <div style={{ fontSize: 14, color: "#94a3b8", lineHeight: 1.7 }}>
            No classical dosha patterns are present in this chart.
          </div>
          <div style={{ fontSize: 12, color: "#64748b", marginTop: 4, lineHeight: 1.6 }}>
            This is a neutral observation — it means this area carries fewer structural
            tensions to be aware of, not that anything is missing.
          </div>
        </div>
      )}

      {/* Awareness Cards */}
      {resolvedAreas.map((area) => (
        <div
          key={area.id}
          style={{
            marginBottom: 20,
            padding: 16,
            borderRadius: 12,
            background: "rgba(30,41,59,0.75)",
            border: "1px solid rgba(148,163,184,0.25)",
            borderLeft: "2px solid rgba(251,191,36,0.4)",
            transition: "box-shadow 0.18s ease, border 0.18s ease",
          }}
          onMouseEnter={(e) => {
            if (isMobile) return;
            e.currentTarget.style.boxShadow =
              "0 8px 20px rgba(0,0,0,0.28)";
            e.currentTarget.style.border =
              "1px solid rgba(251,191,36,0.45)";
          }}
          onMouseLeave={(e) => {
            if (isMobile) return;
            e.currentTarget.style.boxShadow = "none";
            e.currentTarget.style.border =
              "1px solid rgba(148,163,184,0.25)";
          }}
        >
          {/* Summary */}
          <div
            style={{
              fontSize: 16,
              fontWeight: 550,
              marginBottom: 10,
              color: "#f8fafc",
            }}
          >
            {area.summary}
          </div>

          {/* Details */}
          {area.details && (
            <div
              style={{
                fontSize: 14,
                lineHeight: 1.7,
                marginBottom: 10,
                color: "#e2e8f0",
              }}
            >
              {area.details}
            </div>
          )}

          {/* System Context — shown as a quiet note */}
          {area.system_context && (
            <div
              style={{
                fontSize: 12,
                lineHeight: 1.6,
                color: "#64748b",
                marginTop: 6,
                fontStyle: "italic",
              }}
            >
              {area.system_context}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}